export default class PreviewGenerator{
    static renderThumbnails(projects){
        projects.forEach((projectValue, projectKey) => {
            let element = document.querySelector(`#konvaThumb${projectKey}`);
            if(element){
                let image = projectValue.stage.toDataURL({
                    // imageSmoothingEnabled: false,
                    quality: 1,
                    pixelRatio: 0.5
                });
                
                element.src = image;
            }
        });
    }

    static renderPreview(projects){
        projects.forEach((projectValue) => {
            // debugger;
            let element = document.querySelector(`#konvaPreview`);
            if(element){
                let image = projectValue.stage.toDataURL({
                    imageSmoothingEnabled: false,
                    quality: 1,
                    pixelRatio: 2
                });
                
                element.src = image;
            }
        });
    }
}